// What the person typed into the one login field: an email address (code by
// email) or a mobile number (code by SMS). The SERVER is the authority on both
// — this only decides which door to knock on and which icon to draw.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * @param {string} raw
 * @returns {{ kind: 'empty'|'email'|'phone'|'bad_email'|'unknown', value?: string }}
 */
export function classifyLoginIdentifier(raw) {
    const v = String(raw || '').trim();
    if (!v) return { kind: 'empty' };
    if (v.includes('@')) {
        return EMAIL_RE.test(v) ? { kind: 'email', value: v.toLowerCase() } : { kind: 'bad_email' };
    }
    // Anything phone-shaped goes to the server as typed — it owns the
    // canonicalizer (00972…, 050.123.4567, +972…). Only a floor on digits here.
    const digits = v.replace(/\D/g, '');
    if (PHONE_CHARS.test(v) && digits.length >= 9) {
        return { kind: 'phone', value: v };
    }
    return { kind: 'unknown' };
}

const PHONE_CHARS = /^[\d\s()+.-]+$/;

/** Which icon the field shows while typing: letters/@ ⇒ mail, digits ⇒ phone. */
export function identifierLooksLike(raw, { emailAllowed }) {
    const v = String(raw || '').trim();
    if (!emailAllowed) return 'phone';
    if (!v) return 'any';
    return PHONE_CHARS.test(v) ? 'phone' : 'email';
}

export const mmss = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
